(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["_blocks"] && !Shopify.designMode) return;
  try {
    
  setInterval(function() {
    const wrapper = document.querySelector(".video-audio-mute-wrapper");
    if (wrapper) {
      const videos = wrapper.querySelectorAll("video");
      videos.forEach(function(video) {
        if (!video.muted || video.volume > 0) {
          video.muted = true;
          video.volume = 0;
        }
      });
    }
  }, 250);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["piruja"] && !Shopify.designMode) return;
  try {
    
  /* ── Video mute (código original) ── */
  setInterval(function() {
    var wrapper = document.querySelector(".video-audio-mute-wrapper");
    if (wrapper) {
      var videos = wrapper.querySelectorAll("video");
      videos.forEach(function(video) {
        if (!video.muted || video.volume > 0) {
          video.muted = true;
          video.volume = 0;
        }
      });
    }
  }, 250);

  /* ══════════════════════════════════════════════════════════════════
     OCULTAR RESUMEN DE RESEÑAS (LAI Product Reviews)
     
     Estrategia: busca el nodo que contiene el resumen (rating global +
     histograma + botón "Escribe una reseña") y lo oculta.
     No depende de nombres de clases — funciona detectando contenido.
     ══════════════════════════════════════════════════════════════════ */
  (function hideLAISummary() {

    function run() {

      /* -- Intento 1: selectores conocidos de LAI Product Reviews -- */
      var laiSelectors = [
        '.lai-reviews__summary',
        '.lai-summary',
        '.lai-rating-summary',
        '.lai-review-summary',
        '.lai-header',
        '.lai-reviews-header',
        '[class*="lai"][class*="summary"]',
        '[class*="lai"][class*="header"]',
        '[class*="lai"][class*="rating"]',
        /* "Ordenar reseñas" suele estar en una barra justo antes de las cards */
        '[class*="lai"][class*="sort"]',
        '[class*="lai"][class*="filter"]'
      ];

      var found = false;
      for (var i = 0; i < laiSelectors.length; i++) {
        var els = document.querySelectorAll(laiSelectors[i]);
        els.forEach(function(el) {
          /* Solo ocultamos si el elemento contiene el número global de rating
             (texto tipo "5.0" o "4.9") para no ocultar cosas equivocadas     */
          if (/[45]\.\d/.test(el.textContent) || /reseña/i.test(el.textContent)) {
            el.classList.add('lai-summary-hidden');
            found = true;
          }
        });
      }

      if (found) return;

      /* -- Intento 2: búsqueda por contenido --
         Recorre todos los divs y encuentra el que contiene:
         · El rating global (ej. "5.0")
         · Y el texto "reseña" o el botón "Escribe una reseña"
         · Pero NO contiene texto de reseñas individuales largas       */
      var candidates = document.querySelectorAll('div, section, aside');
      for (var j = 0; j < candidates.length; j++) {
        var el = candidates[j];

        /* Debe ser un contenedor de tamaño razonable (no el body entero) */
        if (el.children.length < 2 || el.children.length > 30) continue;

        var txt = el.textContent;

        var hasRating    = /\b[45]\.\d\b/.test(txt);           /* "5.0" */
        var hasResenas   = /reseña/i.test(txt);
        var hasEscribir  = /escribe\s+una\s+reseña/i.test(txt);
        var hasHistogram = /\(\d+\)/.test(txt);                /* "(4)" */

        /* El resumen tiene el rating global + histograma o botón escribir */
        if (hasRating && (hasHistogram || hasEscribir) && hasResenas) {
          /* Verificar que NO sea un contenedor tan grande que incluya
             las cards individuales (más de ~500 caracteres de reseñas) */
          var childTexts = Array.from(el.children).map(function(c) {
            return c.textContent.length;
          });
          var maxChildLen = Math.max.apply(null, childTexts);

          /* Si ningún hijo directo tiene más de 400 chars es el resumen */
          if (maxChildLen < 400) {
            el.classList.add('lai-summary-hidden');
            found = true;
            break;
          }
        }
      }
    }

    /* Ejecutar al cargar y observar cambios (LAI carga via AJAX) */
    run();

    var obs = new MutationObserver(function() {
      obs.disconnect();
      run();
      obs.observe(document.body, { childList: true, subtree: true });
    });
    obs.observe(document.body, { childList: true, subtree: true });

    setTimeout(run, 800);
    setTimeout(run, 2000);
    setTimeout(run, 4000);
  })();

  } catch(e) { console.error(e); }
})();
})();
